<div class="loading-overlay" 
     *ngIf="mostrarModal"
     (click)="cerrarModal()">

  <div class="anuncio anuncio-desktop" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="cerrarModal(); $event.stopPropagation()">
      ✕
    </button>
    <img src="https://www.unipay.cl/api/descargaArchivo/web-anuncio-desktop.jpg" alt="Aviso" />
  </div>

  <div class="anuncio anuncio-movil" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="cerrarModal(); $event.stopPropagation()">
      ✕
    </button>
    <img src="https://www.unipay.cl/api/descargaArchivo/web-anuncio-movil.jpg" alt="Aviso" />
  </div>

</div>

<div class="home-hero">
  <!-- Indicador de dispositivo (solo para desarrollo) -->
  <div class="home-hero__device-indicator" style="position: fixed; top: 10px; right: 10px; background: rgba(0,0,0,0.8); color: white; padding: 5px 10px; border-radius: 5px; font-size: 12px; z-index: 1000;">
    Dispositivo: {{ deviceType }} ({{ getCurrentWidth() }}px)
  </div>

  <!-- Estado de carga -->
  <div *ngIf="isLoading" class="home-hero__loading">
    <div class="home-hero__loading-spinner"></div>
    <p>Cargando carrusel...</p>
  </div>


  <!-- Estado de error -->
  <div *ngIf="error && !isLoading" class="home-hero__error">
    <p>Error al cargar el carrusel. Mostrando contenido por defecto.</p>
  </div>

  <!-- Carrusel dinámico simplificado -->
  <div *ngIf="!isLoading && carouselItems.length > 0" class="home-hero__carousel"
       #sectionElement
       (mouseenter)="onCarouselMouseEnter()"
       (mouseleave)="onCarouselMouseLeave()">
    <app-container>
      <div class="home-hero__card"
      [ngClass]="{
        'home-hero__card--primer': currentSlideIndex === 0,
        'home-hero__card--otros': currentSlideIndex !== 0
      }"
           [class.home-hero__card--white-bg]="currentSlideIndex !== 0"
           [style.background-image]="'url(' + (currentSlide?.img || 'assets/images/web002-invitalos-perro.png') + ')'">

        <!-- Contenido de texto solo para el primer slide -->
        <div *ngIf="currentSlideIndex === 0" class="home-hero__content">
          <div class="home-hero__text-section">
            <h1 class="home-hero__title">
              <span>Descubre Unipay</span>
              <span>La mejor forma de pagar</span>
            </h1>
            <div class="home-hero__separator"></div>

            <div class="home-hero__benefits">
              <div class="home-hero__benefit-item">
                <span class="home-hero__benefit-icon"><img src="https://www.unipay.cl/api/descargaArchivo/web-HUELLA.png" alt="huella"></span>
                <div>
                  <span class="home-hero__subtitle2" >Descuentos únicos pagando sólo con tu huella digital en tus supermercados favoritos</span>
              
                </div>
                
                
              </div>
 <div class="home-hero__partner-logos">
                <img class="home-hero__partner-logo-img" src="https://www.unipay.cl/api/descargaArchivo/web-logoshome.png" alt="supermercados">
              </div>
            </div>

            <button class="home-hero__cta-button" (click)="autoApertura()">
              <span class="home-hero__cta-icon"><img src="assets/dock.svg" alt=""></span>
              Solicita tu Unipay aquí
            </button>


          </div>
        </div>

      </div>
    </app-container>

    <!-- Controles de navegación -->
    <div *ngIf="carouselItems.length > 1" class="home-hero__controls">
      <button class="home-hero__control home-hero__control--prev" (click)="prevSlide()" aria-label="Slide anterior">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <button class="home-hero__control home-hero__control--next" (click)="nextSlide()" aria-label="Siguiente slide">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>

    <!-- Indicadores de slide -->
    <div *ngIf="carouselItems.length > 1" class="home-hero__indicators">
      <button *ngFor="let item of carouselItems; let i = index" class="home-hero__indicator"
        [class.home-hero__indicator--active]="i === currentSlideIndex" (click)="goToSlide(i)"
        [attr.aria-label]="'Ir al slide ' + (i + 1)"></button>
    </div>
  </div>

  <!-- Contenido por defecto simplificado -->
  <div *ngIf="!isLoading && carouselItems.length === 0" class="home-hero__fallback">
    <app-container>
      <div class="home-hero__card" style="background-image: url('assets/images/web002-invitalos-perro.png')">
        <!-- Solo la imagen por defecto -->
      </div>
    </app-container>
  </div>
  <div>
  </div>
</div>
